import useSWR from 'swr'

// libs
import { apiGetService, apiHandleError } from '@/lib'

// types
import { SWRKeys, SWRFetcherData } from './types'

const getUserStats = async ({ data: { userId } }: SWRFetcherData<{ userId: string }>) => {
  // get api service
  const api = apiGetService()

  try {
    // retrieve posts count
    const { count: postsCount } = await api.postApi.getUserPostsCount(userId)

    // retrieve tracks count
    const { count: tracksCount } = await api.trackApi.getUserTracksCount(userId)

    // return payload
    return { postsCount, tracksCount, error: '' }
  } catch (err: any) {
    const { message } = await apiHandleError(err)

    // return payload
    return {
      postsCount: 0,
      tracksCount: 0,
      error: message,
    }
  }
}

const fetcher = (args: SWRFetcherData<{ userId: string }>) => getUserStats(args)

export const useUserStats = (userId: string) => {
  const shouldFetch = !!userId

  const { data, isLoading } = useSWR(
    shouldFetch ? { key: SWRKeys.UseUserStats, data: { userId } } : null,
    fetcher,
    {
      revalidateOnFocus: false,
      // refreshInterval: 3000,
    },
  )

  return {
    postsCount: data?.postsCount,
    tracksCount: data?.tracksCount,
    isLoading,
    isError: data?.error,
  }
}
